import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import SelectBase from '@/components/mui/Form/Select/SelectBase';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

const SourceSelector = ({
  selectedSource,
  onSelectSource,
  actionsEnabled,
  isDuplexAvailable,
  isDuplexOption,
  isFeederOption,
  onToggleFeederOption,
  onToggleDuplexOption,
  removePage,
  singleUpload,
  multiUpload,
  sources,
}) => {
  const { formatMessage } = useIntl();

  const isDisableOptions = useMemo(() => selectedSource === -1, [selectedSource]);

  const options = useMemo(() => sources.map((item) => ({ value: item.id, label: item.value })), [sources]);

  return (
    <Stack direction="row" spacing={2}>
      {actionsEnabled ? (
        <>
          <Button variant="text" startIcon={<InsertDriveFileIcon />} onClick={singleUpload}>
            {formatMessage({ id: 'scan.buttons.uploadSelected', defaultMessage: 'Upload selected' })}
          </Button>
          <Button variant="text" startIcon={<LibraryBooksIcon />} onClick={multiUpload}>
            {formatMessage({ id: 'scan.buttons.uploadAll', defaultMessage: 'Upload all' })}
          </Button>
          <Button variant="text" color="error" startIcon={<DeleteIcon color="error" />} onClick={removePage}>
            {formatMessage({ id: 'scan.buttons.removeSelected', defaultMessage: 'Remove selected' })}
          </Button>
        </>
      ) : (
        <>
          <SelectBase
            id="scanerSource"
            value={selectedSource}
            options={options}
            onChange={onSelectSource}
            sx={{ width: 200, height: 40 }}
          />
          <FormControlLabel
            label={
              <Typography variant="body1">
                {formatMessage({ id: 'scan.options.feeder', defaultMessage: 'Feeder' })}
              </Typography>
            }
            onChange={onToggleFeederOption}
            checked={isFeederOption}
            control={<Switch size="small" />}
            disabled={isDisableOptions}
            sx={{ ml: 0 }}
          />
          <FormControlLabel
            label={
              <Typography variant="body1">
                {formatMessage({ id: 'scan.options.duplex', defaultMessage: 'Duplex scanning' })}
              </Typography>
            }
            onChange={onToggleDuplexOption}
            checked={isDuplexOption}
            control={<Switch size="small" />}
            disabled={isDisableOptions || !isDuplexAvailable}
            sx={{ ml: 0 }}
          />
        </>
      )}
    </Stack>
  );
};

export default SourceSelector;
